/**
 * Zentrale Client-Logik für die „Notify-me-when-available"-Waitlist.
 *
 * Kapselt den kompletten Anti-Spam-Handshake (Rate-Limit → hCaptcha-Retry) und
 * gibt dem Aufrufer ein normalisiertes Ergebnis zurück, damit die 3 Formulare
 * (CartDrawer, ProductDetailPage, ShopCatalogPage) nicht 3× dieselbe Logik
 * duplizieren.
 *
 * Rückgabe:
 *   {
 *     ok: boolean,
 *     status: "ok" | "captcha_required" | "error" | "network",
 *     data?: any,     // Bei ok=true: das Backend-JSON
 *     detail?: string // Fehlermeldung für den Toast
 *   }
 */
export async function postNotifyWaitlist({
  productId,
  email,
  variant,
  honey,
  formTs,
  captchaToken = null,
}) {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/shop/products/${productId}/notify-when-available`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        variant: variant || {},
        website: honey || '',
        form_ts: formTs,
        hcaptcha_token: captchaToken || undefined,
      }),
    });
    let data = null;
    try { data = await res.json(); } catch { /* no body */ }

    if (res.ok) {
      return { ok: true, status: 'ok', data };
    }

    // Sowohl 429 (Rate-Limit soft) als auch 400 (Captcha invalid) können ein
    // strukturiertes `detail`-Objekt mit `captcha_required: true` liefern.
    const detailObj = data?.detail;
    if (
      detailObj &&
      typeof detailObj === 'object' &&
      detailObj.captcha_required
    ) {
      return {
        ok: false,
        status: 'captcha_required',
        detail: detailObj.message || 'Bitte kurz bestätigen, dass du kein Bot bist.',
      };
    }

    return {
      ok: false,
      status: 'error',
      detail:
        (typeof detailObj === 'string' ? detailObj : null) ||
        data?.message ||
        'Anmeldung fehlgeschlagen. Bitte später erneut versuchen.',
    };
  } catch {
    return { ok: false, status: 'network', detail: 'Netzwerkfehler. Bitte später erneut versuchen.' };
  }
}
